
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host .file-input-container {
  display: inline-block;
  width: 100%;
}
:host .file-input-container label.upload-file-button {
  display: flex;
  align-items: center;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  padding: 8px 16px 8px 16px;
  background: var(--slh-color-neutral-shade-20, #EBEEF4);
  border-radius: 4px;
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: var(--slh-base-xs-font-size, 14px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  cursor: grab;
}
:host .file-input-container .icon-wrapper {
  fill: var(--slh-color-neutral-shade-80, #4E5E7E);
  margin-right: 12px;
}
:host .file-input-container .hint-wrapper {
  display: flex;
  flex-direction: row;
  align-items: start;
  margin-bottom: -8px;
}
:host .file-input-container .hint-wrapper .hint-icon-container {
  margin-top: 4px;
  margin-right: -8px;
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
}
:host .file-input-container .hint-wrapper * {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: var(--slh-base-bold-font-weight, 700);
  font-size: var(--slh-base-xxs-font-size, 12px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-60, #62779F);
}
:host .file-input-container .hint-wrapper.hidden {
  display: none;
}
:host .file-input-container .hidden {
  display: none;
}
:host .file-input-container .error-msg {
  display: block;
  font-family: "Open Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #DD5350;
  word-wrap: break-word;
}
:host .file-input-container .uploaded-files {
  margin-bottom: 8px;
  margin-top: 4px;
}
:host .file-input-container .uploaded-files :empty {
  margin: 0;
}
:host .file-input-container slot[name=action-label] {
  display: none;
}

:host > slot[name=label] {
  margin-bottom: 8px;
  display: block;
}
:host .file-input-items-wrapper {
  margin: 0;
}
:host .file-input-items-wrapper:not(:empty) {
  padding-top: 24px;
}
:host .file-input-items-wrapper.drag-drop:not(:empty) {
  padding-top: 40px;
}
:host .file-input-items-wrapper .file-input-item-wrapper:not(:first-of-type) {
  display: block;
  margin-top: 24px;
}
:host .file-input-container .icon-wrapper {
  display: flex;
  flex-shrink: 0;
}
:host .file-input-container label.upload-file-button {
  position: relative;
  white-space: nowrap;
  background: var(--slh-color-neutral-shade-20, #EBEEF4);
  color: var(--slh-color-neutral-shade-80, #4E5E7E);
  padding: 8px 16px;
  line-height: var(--slh-base-xxs-line-height, 24px);
  border-radius: 48px;
  font-size: var(--slh-base-xs-font-size, 14px);
  box-sizing: border-box;
  cursor: pointer;
  text-decoration: none;
  user-select: none;
  text-transform: none;
  font-style: normal;
}
:host .file-input-container label.upload-file-button:hover {
  color: var(--slh-color-neutral, #39455D);
}
:host .file-input-container label.upload-file-button:hover slh-icon {
  fill: var(--slh-color-neutral, #39455D);
}
:host .file-input-container .input-files-holder {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
}
:host .file-input-container .input-files-holder:focus-visible {
  outline: none;
}
:host .file-input-container .input-files-holder:focus-visible label.upload-file-button::after {
  content: "";
  display: block;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  position: absolute;
  top: -4px;
  left: -4px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 48px;
}
:host .file-input-container .input-files-holder:focus {
  filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-18, rgba(78, 94, 126, 0.18)));
  -webkit-filter: drop-shadow(0px 2px 2px var(--slh-color-neutral-shade-80-opacity-18, rgba(78, 94, 126, 0.18)));
}
:host .file-input-container .input-files-holder:focus label.upload-file-button {
  color: var(--slh-color-neutral, #39455D);
}
:host .file-input-container .input-files-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
}
:host .file-input-container .input-files-wrapper.has-label slot[name=label] {
  display: inline-block;
  margin-right: 16px;
}
:host .file-input-container .input-files-wrapper.has-label slot[name=label]::slotted(*) {
  font-size: var(--slh-base-xs-font-size, 14px);
  color: var(--slh-color-neutral-shade-60, #62779F);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  line-height: var(--slh-base-xxs-line-height, 24px);
  font-family: var(--slh-default-font-family, "Open Sans");
}
:host .file-input-container .input-files-wrapper.show-block.has-label slot[name=label] {
  margin-bottom: 16px;
}
:host .file-input-container .input-files-wrapper.show-block {
  flex-direction: column;
  align-items: start;
}
:host .file-input-container .input-files-wrapper.show-block slh-chip {
  position: relative;
  margin-right: 8px;
  margin-bottom: 16px;
}
:host .file-input-container .input-files-wrapper.show-block slh-chip:focus-visible::after {
  content: "";
  display: block;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  position: absolute;
  top: -2px;
  left: -2px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 32px;
  box-sizing: border-box;
}
:host .file-input-container .input-files-wrapper .drag-drop-upload-icon .icon-wrapper {
  margin: 0;
  fill: var(--slh-color-neutral-shade-60, #62779F);
  margin-bottom: 3px;
}
:host .file-input-container .input-files-wrapper .droppable-description-holder slot[name=droppable-description] {
  margin-bottom: 8px;
  margin-top: 8px;
  display: flex;
  color: var(--slh-color-neutral-shade-60, #62779F);
  line-height: var(--slh-base-xxs-line-height, 24px);
  font-size: var(--slh-base-s-font-size, 15px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  font-family: var(--slh-default-font-family, "Open Sans");
}
:host .file-input-container .input-files-wrapper .droppable-description-holder.hidden {
  display: none;
}
:host .file-input-container[error] .has-label slot[name=label]::slotted(*) {
  color: var(--slh-color-error-darken, #FF5C5C);
}
:host .file-input-container[disabled] .drag-drop-upload-icon .icon-wrapper {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host .file-input-container[disabled] .input-files-holder:focus {
  filter: none;
}
:host .file-input-container[disabled] .input-files-holder:focus label.upload-file-button {
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host .file-input-container[disabled] .input-files-holder label.upload-file-button {
  background-color: var(--slh-color-neutral-shade-20, #EBEEF4);
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
  cursor: not-allowed;
}
:host .file-input-container[disabled] .input-files-holder label.upload-file-button slh-icon {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host .file-input-container slot {
  display: none;
}
:host .file-input-container slot[name=action-label], :host .file-input-container slot[name=label] {
  display: block;
}
:host .file-input-container.drag-drop {
  display: flex;
  flex-direction: column;
  width: auto;
  border-style: dashed;
  border-width: 2px;
  border-color: var(--slh-color-neutral-shade-20, #EBEEF4);
  padding: 40px 24px;
  border-radius: 16px;
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host .file-input-container.drag-drop .input-files-wrapper {
  flex-flow: column;
  align-items: center;
}
:host .file-input-container.drag-drop .hint-wrapper, :host .file-input-container.drag-drop .error-holder {
  align-self: center;
}
:host .file-input-container.drag-drop .hint-wrapper {
  margin-top: 16px !important;
}
:host .file-input-container.drag-drop[disabled] {
  background-color: var(--slh-color-neutral-shade-10, #F6F7FA);
}
:host .file-input-container.drag-drop[disabled] slot[name=label]::slotted(*) {
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host .file-input-container.drag-drop[error] {
  border-color: var(--slh-color-error-shade-60, #FFB6AD);
}
:host .file-input-container.drag-drop.highlighted {
  border-color: var(--slh-color-primary, #3B87D4);
  background-color: var(--slh-color-neutral-shade-10, #F6F7FA);
  cursor: move;
}
:host .file-input-container slot[name=error] {
  display: flex;
  align-self: center;
}
:host .file-input-container slot[name=error]::slotted(:not([slot=hint])) {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  color: var(--slh-color-error-darken, #FF5C5C);
  margin: 0;
  text-align: center;
}
:host slh-loader {
  display: flex;
  margin-right: 12px;
}
:host slot[name=hint] {
  display: flex;
}
:host .hint-wrapper .hint-icon-container {
  margin-right: -8px;
}
:host .hint-wrapper * {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: var(--slh-base-bold-font-weight, 700);
  font-size: var(--slh-base-xxs-font-size, 12px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-neutral-shade-60, #62779F);
  word-wrap: break-word;
}
:host .error-holder {
  display: flex;
  align-items: start;
}
:host .error-holder .hidden {
  display: none;
}
:host .error-holder .error-icon-holder {
  margin-top: 4px;
  margin-right: 4px;
}
:host .error-holder .error-icon-holder slh-icon {
  margin-right: 0;
}
:host .error-holder .error-messages-holder {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-style: normal;
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: var(--slh-color-error-darken, #FF5C5C);
  word-wrap: break-word;
}
`;
